import type { App } from 'vue';
import StfContainer from './container/StfContainer.vue';
import StfHeading from '@/ui/typography/StfHeading.vue';
import StfHeadingTwo from '@/ui/typography/StfHeadingTwo.vue';
import StfSubHeading from '@/ui/typography/StfSubHeading.vue';
import StfInfoText from '@/ui/typography/StfInfoText.vue';
import StfBody from '@/ui/typography/StfBody.vue';
import StfCard from '@/ui/card/StfCard.vue';
import StfCardSection from '@/ui/card/StfCardSection.vue';
import StfSheet from '@/ui/sheet/StfSheet.vue';
import StfDivider from '@/ui/divider/StfDivider.vue';
import StfButton from '@/ui/button/StfButton.vue';
import StfIcon from '@/ui/icon/StfIcon.vue';
import StfNavBar from '@/ui/navbar/StfNavBar.vue';
import StfAlert from '@/ui/alert/StfAlert.vue';
import StfRadioChoice from '@/ui/radio-choice/StfRadioChoice.vue';
import StfProgressBar from '@/ui/progress-bar/StfProgressBar.vue';
import StfInput from '@/ui/input/StfInput.vue';
import StfFileInput from '@/ui/file-input/StfFileInput.vue';
import StfCheckbox from '@/ui/checkbox/StfCheckbox.vue';
import StfBulletPoint from '@/ui/list/StfBulletPoint.vue';
import StfRow from '@/ui/columns/StfRow.vue';
import StfCol from '@/ui/columns/StfCol.vue';
import StfDropdown from '@/ui/dropdown/StfDropdown.vue';
import StfDialog from '@/ui/dialog/StfDialog.vue';
import NotificationBanner from '@/components/NotificationBanner.vue';
import StfAutoComplete from '@/ui/autocomplete/StfAutoComplete.vue';

export const registerUiComponent = (app: App) => {
    app.component('StfContainer', StfContainer);
    app.component('StfHeading', StfHeading);
    app.component('StfHeadingTwo', StfHeadingTwo);
    app.component('StfSubHeading', StfSubHeading);
    app.component('StfInfoText', StfInfoText);
    app.component('StfBody', StfBody);
    app.component('StfCardSection', StfCardSection);
    app.component('StfCard', StfCard);
    app.component('StfSheet', StfSheet);
    app.component('StfDivider', StfDivider);
    app.component('StfDropdown', StfDropdown);
    app.component('StfButton', StfButton);
    app.component('StfIcon', StfIcon);
    app.component('StfNavBar', StfNavBar);
    app.component('StfAlert', StfAlert);
    app.component('StfRadioChoice', StfRadioChoice);
    app.component('StfProgressBar', StfProgressBar);
    app.component('StfInput', StfInput);
    app.component('StfFileInput', StfFileInput);
    app.component('StfCheckbox', StfCheckbox);
    app.component('StfBulletPoint', StfBulletPoint);
    app.component('StfRow', StfRow);
    app.component('StfCol', StfCol);
    app.component('StfDialog', StfDialog);
    app.component('NotificationBanner', NotificationBanner);
    app.component('StfAutoComplete', StfAutoComplete);
};
